<template>
  <div class="cooperation_box">
    <div class="pc">
      <div class="header_img">
        业务合作
      </div>

      <div class="purchase_box">
        <div></div>
        <div>
          <Title>我是采购方</Title>
          <p class="desc">无论您是商旅企业、OTA平台还是集团客户，科坦科技通过三大核心能力赋能您的酒店采购</p>
          <div class="cooperation_methods">
            <div class="methodes_title">三种采购方式</div>
            <div class="methods_item">
              <img src="../../../assets/newWebSiteImg/pc/cooperation/m1.png" alt="">
              <div class="content">
                <p class="sub_title">B2B采购网站</p>
                <p class="sub_desc">
                  <span style="display:block;">无需任何技术背景，只需注册开通企业账户即可获取</span>
                  <span>全球旅游资源</span>
                </p>
                <p class="sub_opt">
                  <b2b-button style="width: 130px;height: 35px;line-height: 35px;background-color:#fe8f1d;"
                    @click="toB2B">酒店预订</b2b-button>
                </p>
              </div>
            </div>
            <div class="methods_item">
              <img src="../../../assets/newWebSiteImg/pc/cooperation/m2.png" alt="">
              <div class="content">
                <p class="sub_title">微信小程序</p>
                <p class="sub_desc">在移动端通过微信小程序(筑店订房)随时随地预订。</p>
                <p class="sub_opt">
                  <span style="color: #cdcdcd;font-size: 16px;">微信扫一扫上方小程序码即可</span>
                </p>
              </div>
            </div>
            <div class="methods_item">
              <img src="../../../assets/newWebSiteImg/pc/cooperation/m3.png" alt="">
              <div class="content">
                <p class="sub_title">API系统对接</p>
                <p class="sub_desc">全库存API接口对接服务，15年+技术经验</p>
                <p class="sub_opt">
                  <span style="color: #cdcdcd;font-size: 16px;">联系我们，为您安排需求对接</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div></div>
      </div>

      <div class="supplier_box">
        <div></div>
        <div>
          <Title>我是供应商</Title>
          <p class="desc">作为酒店生态的全球化分销引擎，科坦科技通过智能供应链技术与全渠道网络，赋能您的房源直达TMC差旅管理公司、跨国企业采购系统及旅行社资源库。</p>
          <div>
            <center style="color: #565555;font-weight: bold;font-size: 24px;margin-bottom: 30px;">服务介绍</center>
            <div class="introduce_box">
              <div class="introduce_item">
                <div class="fw_bg">
                  <img src="../../../assets/newWebSiteImg/pc/cooperation/fw1.png" class="fw_item" />
                </div>
                <div class="fw_desc">
                  <p class="fw_title">灵活支持各类价格体系</p>
                  <p class="fw_info"> 团队价、长住优惠、促销包房…各种特殊价格轻松上线，自动同步到所有合作平台，告别手动更新</p>
                </div>
              </div>
              <div class="introduce_item">
                <div class="fw_bg">
                  <img src="../../../assets/newWebSiteImg/pc/cooperation/fw2.png" class="fw_item" />
                </div>
                <div class="fw_desc">
                  <p class="fw_title">智能销售管家系统</p>
                  <p class="fw_info">自动匹配最适合的销售渠道，把复杂资源变成统一标准的可售商品</p>
                </div>
              </div>
              <div class="introduce_item">
                <div class="fw_bg">
                  <img src="../../../assets/newWebSiteImg/pc/cooperation/fw3.png" class="fw_item" />
                </div>
                <div class="fw_desc">
                  <p class="fw_title">省心售后服务组合</p>
                  <p class="fw_info">自动化订单处理退改无忧，账单清晰明了，结算快速到账</p>
                </div>
              </div>
              <div class="process_box">
                <center style="color: #565555;font-weight: bold;font-size: 15px;margin: 20px 0;font-size: 24px;">合作流程
                </center>
                <div class="process_content">
                  <div class="title_bg">
                    <div class="pro_group">
                      <p>供应商申请</p>
                      <img src="../../../assets/newWebSiteImg/pc/cooperation/next.png" alt="">
                    </div>
                  </div>
                  <div class="title_bg">
                    <div class="pro_group">
                      <p>签订供应合作协议</p>
                      <img src="../../../assets/newWebSiteImg/pc/cooperation/next.png" alt="">
                    </div>
                  </div>
                  <div class="title_bg">
                    <div class="pro_group">
                      <p>技术对接服务</p>
                      <img src="../../../assets/newWebSiteImg/pc/cooperation/next.png" alt="">
                    </div>
                  </div>
                  <div class="title_bg">
                    <div class="pro_group">
                      <p>正式上线</p>
                    </div>
                  </div>
                  <div style="grid-column-start: 1;grid-column-end: 5;text-align: center;margin: 35px 0;">
                    <b2b-button
                      style="width: 130px;height: 35px;line-height: 35px;background-color:#fe8f1d;">申请合作</b2b-button>
                  </div>
                </div>
              </div>
            </div>

            <div></div>
          </div>
        </div>
        <div></div>
      </div>

      <div class="choose_us">
        <div></div>
        <div>
          <div style="margin: 35px 0">
            <Title>为什么选择科坦？</Title>
            <div class="explain_box">
              <div class="explain_item">
                <img src="../../../assets/newWebSiteImg/pc/cooperation/1.png">
                <div class="why_desc">
                  <p class="why_title">深耕行业的专家</p>
                  <p class="why_info">15年+垂直领域沉淀，覆盖商旅采购全场景。懂业务痛点的完整解决方案</p>
                </div>
              </div>
              <div class="explain_item">
                <img src="../../../assets/newWebSiteImg/pc/cooperation/2.png">
                <div class="why_desc">
                  <p class="why_title">持续进化的技术引擎</p>
                  <p class="why_info">自主研发动态聚合系统，智能匹配最优资源，毫秒级响应保障流畅体验</p>
                </div>
              </div>
              <div class="explain_item">
                <img src="../../../assets/newWebSiteImg/pc/cooperation/3.png">
                <div class="why_desc">
                  <p class="why_title">企业级安全护航</p>
                  <p class="why_info">智能风控拦截异常操作</p>
                </div>
              </div>
              <div class="explain_item">
                <img src="../../../assets/newWebSiteImg/pc/cooperation/4.png">
                <div class="why_desc">
                  <p class="why_title">开放灵活的生态连接</p>
                  <p class="why_info">支持API/小程序，无缝对接企业现有系统</p>
                </div>
              </div>
              <div class="explain_item">
                <img src="../../../assets/newWebSiteImg/pc/cooperation/5.png">
                <div class="why_desc">
                  <p class="why_title">全时服务护航</p>
                  <p class="why_info">7×24小时多语种支持，问题响应快至10秒</p>
                </div>
              </div>
              <div class="explain_item">
                <img src="../../../assets/newWebSiteImg/pc/cooperation/6.png">
                <div class="why_desc">
                  <p class="why_title">全域渠道智控中心</p>
                  <p class="why_info">直连全球TOP级别商旅平台，智能商旅画像匹配高价值核心客群</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div></div>
      </div>

      <div style="background-color: #e7e7e7;">
        <div class="icon_box">
          <div class="icon_item" v-for="item in iconList" :key="item">
            <img :src="item">
          </div>
        </div>
      </div>
    </div>

    <div class="app">

    </div>
  </div>
</template>

<script>
import Title from '../components/Title.vue';
export default {
  data () {
    return {
      iconList: [
        require('../../../assets/newWebSiteImg/pc/home/partners/expedia.png'),
        require('../../../assets/newWebSiteImg/pc/home/partners/hotelbeds.png'),
        require('../../../assets/newWebSiteImg/pc/home/partners/webbeds.png'),
        require('../../../assets/newWebSiteImg/pc/home/partners/mfmeituan.png'),
        require('../../../assets/newWebSiteImg/pc/home/partners/ctriptavel.png'),
        require('../../../assets/newWebSiteImg/pc/home/partners/alibt.png'),
        require('../../../assets/newWebSiteImg/pc/home/partners/fit.png'),
        require('../../../assets/newWebSiteImg/pc/home/partners/figbig.png'),
        require('../../../assets/newWebSiteImg/pc/home/partners/atour.png'),
        require('../../../assets/newWebSiteImg/pc/home/partners/jinjiang.png'),
      ]
    }
  },
  components: {
    Title
  },
  methods: {
    toB2B () {
      window.open('/Login', '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
.cooperation_box {
  @media screen and (min-width: 992px) {
    .pc {
      display: block;
    }

    .app {
      display: none;
    }
  }

  @media screen and (max-width: 992px) {
    .pc {
      display: none;
    }

    .app {
      display: block;
    }
  }
}


.cooperation_box {
  .pc {
    .header_img {
      height: 350px;
      line-height: 350px;
      text-align: center;
      background-image: url('../../../assets/newWebSiteImg/pc/cooperation/bg1.png');
      background-size: 100% 100%;
      color: #fff;
      font-size: 100px;
      font-weight: 600;
      letter-spacing: 2px;
    }

    .purchase_box {
      margin: 70px 0;
      display: grid;
      grid-template-columns: auto 1401px auto;

      .desc {
        font-size: 14px;
        text-align: center;
        color: #565555;
        margin-top: 70px;
        margin-bottom: 50px;
        color: #b7b6b6;
      }

      .cooperation_methods {
        display: grid;
        grid-template-columns: repeat(3, 440px);
        grid-column-gap: 40.5px;
        margin-bottom: 30px;

        .methodes_title {
          height: 60px;
          line-height: 60px;
          color: #565555;
          font-size: 24px;
          font-family: '苹方';
          grid-column-start: 1;
          grid-column-end: 4;
          text-align: center;
        }

        .methods_item {
          box-shadow: 5px 5px 20px #1312121c;

          img {
            width: 100%;
            height: 485px;
            object-fit: contain;
          }

          .content {
            text-align: center;
            padding: 30px 15px;

            .sub_title {
              font-size: 24px;
              font-family: '苹方';
              color: #565555;
            }

            .sub_desc {
              color: #959494;
              margin: 20px 0;
              line-height: 20px;
              font-size: 14px;
            }

            .sub_opt {
              height: 35px;
              line-height: 35px;
            }
          }
        }
      }
    }

    .supplier_box {
      display: grid;
      grid-template-columns: auto 1401px auto;

      .desc {
        font-size: 14px;
        text-align: center;
        color: #565555;
        margin-top: 60px;
        margin-bottom: 50px;
        color: #b7b6b6;
      }

      .introduce_box {
        display: grid;
        grid-template-columns: repeat(3, 439px);
        grid-column-gap: 40px;

        .introduce_item {
          background-color: #fff;
          box-shadow: 5px 5px 20px #1312121c;

          .fw_bg {
            height: 165px;
            background-image: url('../../../assets/newWebSiteImg/pc/cooperation/fw_bg.png');
            background-size: 100% 100%;
            position: relative;

            .fw_item {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 90px;
              height: 90px;
            }
          }



          .fw_desc {
            text-align: center;
            padding: 25px 40px;

            .fw_title {
              font-size: 24px;
              color: #565555;
              margin-bottom: 20px;
            }

            .fw_info {
              color: #959494;
              font-size: 14px;
              line-height: 20px;
            }
          }
        }

        .process_box {
          grid-column-start: 1;
          grid-column-end: 4;
          padding: 0 60px;
          margin-top: 40px;

          .process_content {
            display: grid;
            grid-template-columns: repeat(4, 25%);

            .title_bg {
              background-image: url('../../../assets/newWebSiteImg/pc/cooperation/process_bg.png');
              height: 60px;
              background-size: contain;
              position: relative;

              .pro_group {
                width: 100%;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                display: grid;
                grid-template-columns: 90% 10%;
                align-items: center;
                text-align: center;

                p {
                  font-size: 18px;
                }

                img {
                  width: 9px;
                  height: 16px;
                }
              }
            }
          }
        }
      }
    }

    .choose_us {
      display: grid;
      grid-template-columns: auto 1401px auto;
      margin-top: 30px;

      .explain_box {
        display: grid;
        grid-template-columns: repeat(3, 442px);
        grid-gap: 40px;
        margin: 60px 0;
        margin-bottom: 100px;

        .explain_item {
          box-shadow: 5px 5px 20px #1312121c;

          img {
            width: 100%;
            height: 189px;
            object-fit: cover;
          }

          .why_desc {
            padding: 35px 25px;
            text-align: center;

            .why_title {
              font-size: 24px;
              color: #565555;
              margin-bottom: 15px;
            }

            .why_info {
              color: #959494;
              line-height: 20px;
              font-size: 14px;
            }
          }
        }
      }
    }

    .icon_box {
      width: 1401px;
      margin: auto;
      height: 110px;
      padding: 20px 0;
      background-color: #e7e7e7;
      display: grid;
      grid-template-columns: repeat(10, 130px);
      grid-column-gap: 11px;

      .icon_item {
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newWebsite/main/cooperation.vue